import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import ContentList from "../../../Component/List/contentList";
import DocumentDetail from "./documentDetail";
import useReactRouter from "use-react-router";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // height: "100vh",
    height: "100%",
  },

  leftContent: {
    // height: "100%",
    // width: "100%",
    // display: "flex",
    // flexDirection: "column",
    // alignItems: "center",
    // justifyContent: "flex-start",
    // backgroundColor: "#efefef",
    // overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {},
  },
  rightContent: {
    height: "100%",
    width: "100%",
    // minHeight: "100vh",
    // maxHeight: "100vh",
    // display: "flex",
    // flexDirection: "column",
    // alignItems: "center",
    // justifyContent: "center",
    backgroundColor: "#FFFFFF",
    //overflowY: "scroll",
  },
}));

const Docpage = () => {
  const classes = useStyle();
  const { history } = useReactRouter();
  const [open, setOpen] = useState(true);

  const check = () => {
    let arr = [
      "intro",
      "accesstoken",
      // "api",
      // "ratelimit",
      "response",
      "mea_data_service",
      "mea_map_service",
      "scs",
      "address",
    ];
    arr.map((rs) => {
      let doc = document.getElementById(rs);
      if (
        window.scrollY - doc.offsetTop > 0 &&
        window.scrollY - doc.offsetTop < 100
      ) {
        return history.push(`/home/document#${rs}`);
      } else {
        return null;
      }
    });
  };
  useEffect(() => {
    window.addEventListener("scroll", check);
    return () => {
      window.removeEventListener("scroll", check);
    };
  });

  return (
    <div className={classes.root} id="doc">
      <Grid container spacing={0}>
        <Grid item md={2} sm={3} className={classes.leftContent}>
          <div id="sticky">
            <ContentList open={open} setOpen={setOpen} />
          </div>
        </Grid>
        <Grid item md={10} sm={12} xs={12}>
          <div className={classes.rightContent} id="doc_content">
            <DocumentDetail />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Docpage;
